// id
export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID;
export const GA4_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID;

// categories
export const ADD_TO_CART = 'add_to_cart';
export const CHECKOUT = 'checkout';
export const ORDER_SUMMARY = 'order_summary';
export const ORDER_HISTORY = 'order_history';

// handles event for pageview
export const GTMPageView = (url) => {
  const pageEvent = {
    event: 'pageview',
    page: url,
  };
  // eslint-disable-next-line no-unused-expressions
  window && window.dataLayer && window.dataLayer.push(pageEvent);
  return pageEvent;
};

// Exposes the GA4 measurement ID to the GTM container as a Data Layer Variable
// (referenced in GTM as {{DLV - ga4MeasurementId}}), so GTM's own Google Tag
// config owns GA4 initialization per environment/brand — no second, directly
// initialized gtag.js instance racing GTM's for the same property.
export const pushGA4MeasurementId = () => {
  if (typeof window === 'undefined' || !GA4_MEASUREMENT_ID) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ga4MeasurementId: GA4_MEASUREMENT_ID });
};
